import React, { useEffect, useRef, useState } from "react";
import Button from "react-bootstrap/Button";
import { TbMap2, TbMapOff } from "react-icons/tb";
import "@arcgis/map-components/components/arcgis-map";
import "@arcgis/map-components/components/arcgis-zoom";
import "@arcgis/map-components/components/arcgis-feature";
import "@arcgis/map-components/components/arcgis-expand";
import Graphic from "@arcgis/core/Graphic.js";
import esriConfig from "@arcgis/core/config.js";

const ViewerMap = ({ coords }) => {
  esriConfig.portalUrl = "https://gis.thompsoncs.net/arcgis";
  const previousPoint = useRef();
  const [showMap, setShowMap] = useState(false);

  useEffect(() => {
    const mapElement = document.querySelector("arcgis-map");

    if (mapElement) {
      const point = {
        type: "point",
        longitude: coords?.x,
        latitude: coords?.y,
      };

      const simpleMarker = {
        type: "simple-marker",
        color: [248, 153, 28],
        outline: {
          color: [255, 255, 255],
          width: 1,
        },
      };

      const pointGraphic = new Graphic({
        geometry: point,
        symbol: simpleMarker,
      });

      mapElement.graphics.remove(previousPoint.current);
      mapElement.graphics.add(pointGraphic);
      previousPoint.current = pointGraphic;
    }
  }, [coords, previousPoint, showMap]);

  const handleShowHide = () => {
    setShowMap((prev) => !prev);
  };

  return showMap ? (
    <div
      style={{
        position: "absolute",
        zIndex: 999,
        maxWidth: "400px",
        minWidth: "300px",
        width: "35%",
        maxHeight: "300px",
        minHeight: "200px",
        height: "300px",
        top: "clamp(200px, 60%, 720px)",
        right: "2%",
        backgroundColor: "rgba(61, 61, 61, 0.5)",
        marginBottom: "200px",
      }}
    >
      <arcgis-map
        item-id="cc93f41af383470594965e115c754a8c"
        center={[coords.x, coords.y]}
        zoom={18}
        autoDestroyDisabled={true}
      >
        <Button
          slot="top-right"
          size="sm"
          variant="light"
          style={{ width: "32px" }}
          onClick={handleShowHide}
        >
          <TbMapOff />
        </Button>
        <arcgis-zoom slot="bottom-right"></arcgis-zoom>
      </arcgis-map>
    </div>
  ) : (
    <Button
      size="sm"
      variant="light"
      style={{
        position: "absolute",
        zIndex: 999,
        top: "clamp(100px, 90%, 1000px)",
        right: "2%",
        paddingBottom: "8px",
      }}
      onClick={handleShowHide}
    >
      <TbMap2 />
    </Button>
  );
};

export default ViewerMap;
